import React from "react";
import { Button } from "semantic-ui-react";
import { DeleteDialog, Modal } from "../../../components";
import { routes } from "utilities/routing/generatedRoutes";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  flight: server.dto.Flight
  canCopy: boolean
}

const FlightOptionsPanel = (props: Props) => {
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [isCopyModalOpen, setIsCopyModalOpen] = React.useState(false);
  const [isCopying, setIsCopying] = React.useState(false);

  const onDelete = async () => {
    await window.Api.Flights.Delete(props.flight.id);
    window.location.href = props.listUrl;
  };

  const onCopy = async () => {
    if (isCopying) return;
    setIsCopying(true);

    const res = await window.Api.Flights.CopyFlight(props.flight.id);
    window.location.href = routes.flight_Detail(res.data).absolute;
  };

  return <>
    <GeneralOptionsPanel
      data={props.optionsPanelData}
      links={[
        { href: props.listUrl, text: RESX.Buttons.ListView, visible: true },
        { onClick: () => { setIsCopyModalOpen(true); }, text: RESX.OptionsPanel.Copy, visible: props.canCopy },
        { onClick: () => { setIsDeleting(true); }, text: RESX.Buttons.btnDelete, visible: props.flight.permissions.canDelete }
      ]}
    />
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />

    <Modal
      isOpen={isCopyModalOpen}
      handleClose={() => { setIsCopyModalOpen(false); }}
      title={RESX.OptionsPanel.Copy}
    >
      <div className="grow1">
        {RESX.GeneralWarnings.AreYouSure}
      </div>

      <div className="flex">
        <div className="grow1"></div>
        <Button primary onClick={onCopy} loading={isCopying} disabled={isCopying}>
          {RESX.Buttons.BtnOk}
        </Button>
      </div>
    </Modal>
  </>;
};

export default FlightOptionsPanel;